import { getTelegramWebApp } from './telegram';

export const haptics = {
  success: () => getTelegramWebApp()?.HapticFeedback.notificationOccurred('success'),
  error: () => getTelegramWebApp()?.HapticFeedback.notificationOccurred('error'),
  warning: () => getTelegramWebApp()?.HapticFeedback.notificationOccurred('warning'),
  impactLight: () => getTelegramWebApp()?.HapticFeedback.impactOccurred('light'),
  impactMedium: () => getTelegramWebApp()?.HapticFeedback.impactOccurred('medium'),
  selection: () => getTelegramWebApp()?.HapticFeedback.selectionChanged(),
};
